import type { IconProps } from './types';
import './icons.css';

export default function ChangeLogAdded({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-change-log-added ${className || ''}`}
    >
      <g clipPath="url(#change-log-added-a)">
        <path
          fill="#1BCA61"
          d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm2.667 9a1 1 0 1 0 0-2H9V5.333a1 1 0 1 0-2 0V7H5.333a1 1 0 1 0 0 2H7v1.667a1 1 0 1 0 2 0V9h1.667Z"
        />
      </g>
      <defs>
        <clipPath id="change-log-added-a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
